import RadioButton from "@frameworks/web/components/generic/radioButton";
import React from "react";
import { Col, Row } from "react-bootstrap";
import BankAccount from "../CommonPaymentMethod/BankAccount";
export var DiffUpiId = [
    {
        value: "bA1",
        display: "",
    },
    {
        value: "bA2",
        display: "",
    },
    {
        value: "bA3",
        display: "",
    },
];
var DiffrentUpiIdData = function (props) {
    return (React.createElement(React.Fragment, null,
        React.createElement(Row, null,
            React.createElement(Col, { lg: 12, className: "BankAccountSectionOuter mt-2" }, props.upiList.map(function (item) {
                return (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: "BankAccountSection" },
                        React.createElement(RadioButton, { className: "common-radio-button paymentmethodradio", name: "upi", list: { display: "", value: item.upi }, onChange: function () {
                                props.setUPI(item.upi);
                            }, selected: props.selectedUPI, key: 0 }),
                        React.createElement(BankAccount, { sectionHeadleftTop: "Bank Account Number", sectionHeadleftBottom: item.bankaccountnumber, sectionHeadRightTop: "Bank Name", sectionHeadRightBottom: item.bankName, sectionHeadleft2Top: "UPI ID", sectionHeadleft2Bottom: item.upi }))));
            })))));
};
export default DiffrentUpiIdData;
